import { render, staticRenderFns } from "./modifierPays.vue?vue&type=template&id=63553f04&scoped=true"
import script from "./modifierPays.vue?vue&type=script&lang=js"
export * from "./modifierPays.vue?vue&type=script&lang=js"
import style0 from "./modifierPays.vue?vue&type=style&index=0&id=63553f04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63553f04",
  null
  
)

export default component.exports